// extracted by mini-css-extract-plugin
export default {"wrapper":"input-search_wrapper__y1zlp","icon":"input-search_icon__Pz7Dv","input":"input-search_input__nuDSv"};